import crud from "./CRUD"

const PATH = "/productVariants"

export const getProductVariant = async (args) => crud.get(PATH + args)
